var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreatmentFinder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "58px",
    viewBox: "0 0 61 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Treatment Finder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.00997875,0 C2.24304389,0 0,2.24553095 0,5.00003191 L0,44.9999681 C0,47.7614095 2.24349151,50 5.00997875,50 L53,50 L53,0 L5.00997875,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.2%",
    y: "-10.0%",
    width: "126.4%",
    height: "128.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45283019,14 C12.9433962,14 14,11.2276094 14,7.80769231 C14,4.3877752 12.9433962,0 7.13207547,0 C1.32075472,0 0,4.3877752 0,7.80769231 C0,11.2276094 3.96226415,14 8.45283019,14 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45283019,14 C12.9433962,14 14,11.2276094 14,7.80769231 C14,4.3877752 12.9433962,0 7.13207547,0 C1.32075472,0 0,4.3877752 0,7.80769231 C0,11.2276094 3.96226415,14 8.45283019,14 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26923077,14 C10.7634939,14 14,11.6292998 14,8 C14,4.37070022 10.6288785,0 7.13461538,0 C3.64035226,0 0,3.22784307 0,6.85714286 C0,10.4864426 3.77496764,14 7.26923077,14 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0 0 16.2783913 0 16.2783913 17.2392337 0 17.2392337"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WEBAPP-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "match-mobile01",
    transform: "translate(-263.000000, -499.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-3",
    transform: "translate(267.000000, 501.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paper-shadow-z=\"1\"-copy-10"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0C9BED",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "notalone-copy",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(16.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F4BC5A",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.684211, 1.496183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66110912,0.555296391 C7.26383541,-0.0616995989 7.86656171,-0.164532264 8.469288,0.246798396 C9.37337744,0.863794385 9.0720143,2.40628436 9.0720143,2.40628436 C9.0720143,2.40628436 8.77065115,3.02328035 8.469288,3.02328035 C8.16792485,3.02328035 8.469288,4.87426832 8.16792485,5.49126431 C7.96701609,5.90259497 7.56519856,6.21109296 6.96247227,6.41675829 C3.9488408,5.38843164 2.34157068,4.56577032 2.14066192,3.94877433 C1.83929877,3.02328035 1.83929877,1.48079037 2.74338821,0.863794385 C3.64747765,0.246798396 4.85293024,0.246798396 5.15429339,0.246798396 C5.35520215,0.246798396 5.85747406,0.349631061 6.66110912,0.555296391 Z",
    id: "Path-10",
    fill: "#6648E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70806367,3.31085809 C2.50674478,4.74556326 2.50674478,5.66787372 2.70806367,6.07778949 C2.90938255,6.48770525 3.31202031,6.79514207 3.91597696,7.00009995 L3.91597696,7.92241042 C4.11729584,8.53728406 4.31861472,8.84472089 4.5199336,8.84472089 C4.72125248,8.84472089 5.12389025,8.63976301 5.72784689,8.22984724 L5.72784689,7.30753678 C6.33180353,7.10257889 6.7344413,6.79514207 6.93576018,6.38522631 C7.13707906,5.97531055 7.2377385,5.66787372 7.2377385,5.46291584 C7.64037627,5.46291584 7.84169515,5.25795796 7.84169515,4.8480422 C7.84169515,4.23316855 7.84169515,3.92573173 7.53971682,3.92573173 C7.33839794,3.92573173 7.2377385,3.92573173 7.2377385,3.92573173 L6.02982521,2.0811108 C5.42586857,2.69598444 4.92257136,3.00342126 4.5199336,3.00342126 C4.11729584,3.00342126 3.51333919,3.1059002 2.70806367,3.31085809 Z",
    id: "Path-9",
    fill: "#FAD9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.3000665 C0.200777702,9.87310605 0.501944255,9.05770006 0.903499658,8.85384857 C1.30505506,8.64999707 2.00777702,8.44614557 3.01166553,8.24229408 L3.91516519,7.63073959 C3.99296655,8.40505676 4.19374425,8.81275975 4.51749829,8.85384857 C4.84125234,8.89493738 5.24280774,8.58916014 5.7221645,7.93651683 C6.72605301,8.34421983 7.42877497,8.64999707 7.83033037,8.85384857 C8.43266348,9.15962581 9.03499658,10.0769575 9.03499658,10.3827348 C9.03499658,10.5865863 9.03499658,11.096215 9.03499658,11.911621 L9.03499658,12.8289527 L0.602333105,13.4405072 L0,11.3000665 Z",
    id: "Path-11",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6648E6",
    cx: 3.62252221,
    cy: 4.68249929,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-10",
    fill: "#6648E6",
    cx: 5.75341763,
    cy: 4.68249929,
    rx: 1,
    ry: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(30.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#47C1AD",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.671642, 1.816794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33972185,7.87232544 C2.79867707,7.81720998 2.33878901,7.51407493 1.96005767,6.96292029 C1.58132632,6.41176565 1.47311737,5.80549554 1.6354308,5.14410997 L0.986177069,4.81341719 C1.1484905,4.6480708 1.22964722,4.28982028 1.22964722,3.73866564 C1.22964722,2.91193368 1.96005767,1.83718213 1.96005767,1.83718213 C1.96005767,1.83718213 3.25856513,0.101045017 3.90781886,0.101045017 C4.55707259,0.101045017 6.0990502,0.0183718213 6.50483379,0.0183718213 C6.77535617,0.0183718213 7.37050543,0.514410997 8.29028155,1.50648935 C8.93953528,2.44345224 9.15595319,3.04972234 8.93953528,3.32529966 C8.61490841,3.73866564 8.29028155,4.48272441 8.29028155,4.81341719 C8.29028155,5.14410997 8.5337517,5.30945637 8.29028155,5.72282235 C8.0468114,6.13618833 7.5598711,6.88024709 7.5598711,7.37628627 C7.5598711,7.87232544 6.50483379,9.02975019 6.50483379,9.02975019 C6.50483379,9.02975019 5.44979647,8.64394194 3.33972185,7.87232544 Z",
    id: "Path-12",
    fill: "#F1BC5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68785424,3.04499021 C2.48803773,4.47196112 2.48803773,5.38929956 2.68785424,5.79700553 C2.88767074,6.20471151 3.28730374,6.51049099 3.88675325,6.71434398 L3.88675325,7.63168242 C4.08656975,8.24324138 4.28638625,8.54902086 4.48620275,8.54902086 C4.68601925,8.54902086 5.08565226,8.34516788 5.68510176,7.9374619 L5.68510176,7.02012346 C6.28455127,6.81627047 6.68418427,6.51049099 6.88400078,6.10278502 C7.08381728,5.69507904 7.18372553,5.38929956 7.18372553,5.18544657 C7.58335853,5.18544657 7.78317503,4.98159359 7.78317503,4.57388761 C7.78317503,3.96232865 7.78317503,3.65654917 7.48345028,3.65654917 C7.28363378,3.65654917 7.18372553,3.65654917 7.18372553,3.65654917 L5.98482652,1.82187228 C5.38537701,2.43343124 4.88583576,2.73921073 4.48620275,2.73921073 C4.08656975,2.73921073 3.48712024,2.84113722 2.68785424,3.04499021 Z",
    id: "Path-9",
    fill: "#FAD9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.9911301 C0.199279361,9.57186217 0.498198402,8.7608519 0.896757123,8.55809934 C1.29531585,8.35534677 1.99279361,8.1525942 2.98919041,7.94984164 L3.88594754,7.34158394 C3.96316829,8.11172689 4.16244765,8.51723202 4.48378562,8.55809934 C4.80512359,8.59896665 5.20368231,8.2948378 5.67946178,7.64571279 C6.67585859,8.05121792 7.37333635,8.35534677 7.77189507,8.55809934 C8.36973315,8.86222819 8.96757123,9.77461473 8.96757123,10.0787436 C8.96757123,10.2814961 8.96757123,10.7883776 8.96757123,11.5993878 L8.96757123,12.5117744 L0.597838082,13.1200321 L0,10.9911301 Z",
    id: "Path-11",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6648E6",
    cx: 3.59548847,
    cy: 4.40923712,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-10",
    fill: "#6648E6",
    cx: 5.71048168,
    cy: 4.40923712,
    rx: 1,
    ry: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-3",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#6B44FA",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-10)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -0.451613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.4234325,9.62932521 L11.4234325,14.7615448 C10.4737733,15.3284106 9.37859634,15.6514095 8.21277531,15.6514095 C7.43556128,15.6514095 6.68950427,15.5077741 5.99730206,15.24415 L5.99730206,9.62932521 C5.99730206,9.23865626 6.29431069,8.92205953 6.66076879,8.92205953 L7.73376454,8.92205953 C7.84273335,8.92205953 7.94931292,8.95014639 8.04572208,9.00504656 L8.39900705,9.20550964 C8.59421459,9.31592955 8.82774687,9.31592955 9.02234096,9.20550964 L9.37682056,9.00504656 C9.47261625,8.95014639 9.57980928,8.92205953 9.68816464,8.92205953 L10.7599981,8.92205953 C11.1264239,8.92205953 11.4234325,9.23865626 11.4234325,9.62932521",
    id: "Fill-5",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6",
    fill: "#FAD9B0",
    points: "9.5414862 8.6686458 9.40772047 7.48545672 8.01301408 7.48545672 7.78221339 9.52694492 9.63852117 9.52694492 9.5414862 8.6686458"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FFFFFF",
    points: "7.21104176 9.76154566 5.22904638 14.0498608 3.32002945 14.0498608 5.97556467 8.92205953"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7-Copy",
    fill: "#FFFFFF",
    transform: "translate(11.988595, 11.661333) scale(-1, 1) translate(-11.988595, -11.661333) ",
    points: "13.9341014 9.93691818 11.952106 14.2252333 10.0430891 14.2252333 12.6986243 9.09743205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85316018,12.7895849 L8.13984581,12.734815 L7.51249965,12.6867036 L6.73405686,12.6269826 L6.63987014,13.9725665 L7.81753025,14.0629504 C7.8757773,14.0673894 7.93014339,14.0483019 7.97283397,14.0135756 C8.02080789,13.9745811 8.08179444,13.957474 8.14235702,13.9620837 L8.76771378,14.0100927 L8.85316018,12.7895849",
    id: "Fill-10",
    fill: "#F8CA9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7718679,12.9290374 L6.14522482,12.8814772 C6.05770628,12.8748207 5.99130403,12.7952431 5.99773213,12.7045824 C6.00412808,12.6139218 6.08100813,12.5451608 6.16855882,12.5518172 L6.79523403,12.5993775 C6.87227478,12.6052351 6.93070619,12.6752941 6.9250816,12.755138 L6.92228538,12.7945441 C6.91662865,12.8743881 6.84894079,12.9348618 6.7718679,12.9290374",
    id: "Fill-11",
    fill: "#F8CA9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27166649,13.3070867 L6.64500462,13.2595597 C6.5574513,13.2529033 6.49107921,13.1732923 6.4975075,13.0826316 C6.50390365,12.9920042 6.580786,12.9232432 6.66833931,12.9298663 L7.29500118,12.9774266 C7.37207638,12.9832842 7.43050954,13.0533765 7.42485264,13.1331872 L7.42205634,13.1725934 C7.41639944,13.2524373 7.34874169,13.3129444 7.27166649,13.3070867",
    id: "Fill-12",
    fill: "#F8CA9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34304419,13.6851401 L6.71642015,13.6376131 C6.62887213,13.6309234 6.56250404,13.5513457 6.5688998,13.460685 C6.5753277,13.3700575 6.65220541,13.3012965 6.73975344,13.3079197 L7.36637748,13.3554799 C7.44344802,13.3613376 7.50187766,13.4313966 7.49625324,13.5112406 L7.4934571,13.5506467 C7.48780055,13.6304907 7.42011474,13.6909977 7.34304419,13.6851401",
    id: "Fill-13",
    fill: "#F8CA9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68545571,12.9504454 L7.12682791,12.3753185 C7.05244416,12.298725 7.04834402,12.168874 7.1177097,12.0867419 C7.18710598,12.0046437 7.30478592,12.0001183 7.37916967,12.0767456 L7.93782807,12.6518387 C8.01221182,12.7283984 8.01631196,12.8582495 7.94691568,12.9403815 C7.8775194,13.0224798 7.75987006,13.0270051 7.68545571,12.9504454",
    id: "Fill-15",
    fill: "#F8CA9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4440259,5.26408038 C10.4440259,5.26408038 10.4333767,4.73009749 10.8620386,4.85922487 C11.1087115,4.93346975 11.221218,5.30638073 11.0681198,5.65082162 C10.9150544,5.99526251 10.6077733,6.24619737 10.4440259,6.27321697 C10.0774184,6.33366532 10.4440259,5.26408038 10.4440259,5.26408038",
    id: "Fill-16",
    fill: "#FAD9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.963133,5.26408038 C6.963133,5.26408038 6.97463384,4.73009749 6.51025644,4.85922487 C6.24306675,4.93346975 6.12118638,5.30638073 6.28700493,5.65082162 C6.45285908,5.99526251 6.7857424,6.24619737 6.963133,6.27321697 C7.3602857,6.33366532 6.963133,5.26408038 6.963133,5.26408038",
    id: "Fill-17",
    fill: "#FAD9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71039967,8.39278481 C8.45219409,8.39278481 8.11990588,8.27051876 7.83605379,7.99022668 C7.03043796,7.19210395 5.03608477,2.26832022 8.71039967,2.26832022 C12.3846817,2.26832022 10.3903614,7.19210395 9.58415445,7.99022668 C9.30086061,8.27051876 8.9685724,8.39278481 8.71039967,8.39278481 Z",
    id: "Fill-18",
    fill: "#FAD9B0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6B44FA",
    cx: 9.87093941,
    cy: 5.68527919,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#6B44FA",
    cx: 8.09590206,
    cy: 5.68527919,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74663645,5.67080055 L6.87621235,4.04665849 C6.87621235,4.04665849 7.83731787,5.2172212 9.153689,4.81335104 C8.68717662,4.40595469 8.56555857,3.99338885 8.56555857,3.99338885 C8.56555857,3.99338885 9.37259498,4.79191994 10.4932162,4.44231225 C10.5807851,5.15087379 10.640208,5.62181028 10.640208,5.62181028 C10.640208,5.62181028 10.9236573,4.96576521 10.9236573,4.25905236 C10.9236573,3.55230527 10.7364197,1.81465618 8.57077683,1.81518776 C8.57077683,1.81518776 7.61097587,1.77728962 7.34223552,2.34148222 C6.84310902,2.34148222 6.23081152,3.08280665 6.2864186,4.03529248 C6.32767546,4.74179992 6.74663645,5.67080055 6.74663645,5.67080055",
    id: "Fill-19",
    fill: "#F3BC57"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-20",
    fill: "#FFFFFF",
    points: "8.71036728 9.39467683 7.80848377 9.99010326 6.90597004 10.5854944 6.8540595 8.92205953 7.87668063 8.92205953 8.71036728 9.39467683"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-21",
    fill: "#FFFFFF",
    points: "10.5666751 8.92205953 10.5147313 10.5854944 9.61288101 9.99010326 8.71036728 9.39467683 9.54465098 8.92205953 10.5666751 8.92205953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4626012,16.1543311 L11.4626012,8.52562633 L11.4626012,16.1543311 Z M11.7372709,9.43464472 C11.5770067,9.11932153 11.2655757,8.92205953 10.9263308,8.92205953 L9.55787351,8.92205953 L9.19198857,10.9928114 L8.80559372,12.7514413 L8.66649158,12.7405989 L8.28254227,10.9928114 L7.91848332,8.92205953 L5.99730206,8.92205953 L5.99730206,15.24415 C6.69636696,15.5077741 7.44982061,15.6514095 8.23474017,15.6514095 C9.4121195,15.6514095 10.5181544,15.3284106 11.4772288,14.7615448 L11.4772288,14.5023954 L11.7372709,9.43464472 Z",
    id: "Fill-23",
    fill: "#48C0AD"
  })))), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#47C1AD",
    transform: "translate(22.108374, 19.981752) rotate(12.000000) translate(-22.108374, -19.981752) ",
    points: "13.8670124 19.3625988 30.3472428 19.3970553 30.3497364 20.6009049 13.869506 20.5664483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-24",
    fill: "#6B44FA",
    transform: "translate(14.459379, 12.876252) rotate(-56.000000) translate(-14.459379, -12.876252) ",
    points: "10.2057413 12.2984288 18.7187002 12.2581222 18.0003721 13.3087442 10.200057 13.4943811"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-25",
    fill: "#F4BC5A",
    transform: "translate(32.954726, 13.722579) rotate(34.000000) translate(-32.954726, -13.722579) ",
    points: "28.7145316 13.1223061 37.1949207 13.1626126 36.3840198 14.1215458 28.7202159 14.3228515"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentFinder);
export default __webpack_public_path__ + "static/media/treatmentFinder.141a7db3026965eaccc46bd2cb636b9f.svg";
export { ForwardRef as ReactComponent };